import { TextField } from "@fluentui/react";

const ContentApiWhitelistFields = ({ values, onChange, disabled }) => (
  <>
    {/*Whitelist IPs here if we end up needing that in the future*/}

    <TextField
      label="Whitelist Origins (one per line or comma separated)"
      value={values.whitelistOrigins}
      onChange={(_, newValue) => onChange("whitelistOrigins", newValue || "")}
      className="mt10"
      multiline
      rows={4}
      disabled={disabled}
    />
  </>
);

export default ContentApiWhitelistFields;
